/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSyncErrorModel } from '../../models/data-sync-error-model';

export interface DataSyncLogFailedSyncTaskPost$Params {
      body?: DataSyncErrorModel
}

export function dataSyncLogFailedSyncTaskPost(http: HttpClient, rootUrl: string, params?: DataSyncLogFailedSyncTaskPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, dataSyncLogFailedSyncTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

dataSyncLogFailedSyncTaskPost.PATH = '/DataSync/LogFailedSyncTask';
